import React from 'react'
import StoreListing from './Listing'

const index = () => {
  return (
    <div>
      <StoreListing />
    </div>
  )
}

export default index
